package se.mittpass.shared.repository

import io.ktor.client.*
import io.ktor.client.call.body
import io.ktor.client.request.*
import io.ktor.http.*
import se.mittpass.shared.api.*

class TimeBankRepository(private val httpClient: HttpClient) {
    suspend fun getBalances(workplaceId: Long): Result<List<TimeBankBalanceDto>> = runCatching {
        httpClient.get("workplaces/$workplaceId/timebank/balances").body()
    }

    suspend fun getEntries(workplaceId: Long, userId: Long? = null): Result<List<TimeBankEntryDto>> = runCatching {
        httpClient.get("workplaces/$workplaceId/timebank") {
            userId?.let { parameter("userId", it) }
        }.body()
    }

    suspend fun createEntry(workplaceId: Long, req: CreateTimeBankEntryRequest): Result<Unit> = runCatching {
        httpClient.post("workplaces/$workplaceId/timebank") { setBody(req) }
    }
}
